import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Fournisseur } from './../../models/fournisseur';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FournisseurService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }
  getHeaderElementssalariecf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeadesalariecf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
  /* create fournisseur */
  createfournisseur(body: any): Observable<ApiResponse<Fournisseur>> {
    return this._http.post<ApiResponse<Fournisseur>>(
      this._base + '/api/EsnClient/unitaryAddFournisseur',
      body
    );
  }

  /* update fournisseur */
  updateFournisseur(body: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/EsnClient/updateFournisseur',
      body
    );
  }
  /* update fournisseur individuel */
  updatefournisseurind(body: any): Observable<ApiResponse<Fournisseur>> {
    return this._http.post<ApiResponse<Fournisseur>>(
      this._base + '/api/EsnClient/updateFournisseurIndiv',
      body
    );
  }
  /* update fournisseur */
  updateSupplier(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Mailing/update/`,
      data
    );
  }

  // /* get list Fournisseur */

  getListFournisseurr(data: {
    clientFinal_id: number;
    type?: [];
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EsnClient/getListForunisseur?
  clientFinal_id=${data.clientFinal_id}&type[]=2&per_page=${data.per_page}&page=${data?.page}${sort}`);
  }
  
  changeEmail(body:any): Observable<any> {
    return this._http.post<
    ApiResponse<any>
  >(this._base + `/api/User/changeEmail`,body);
  }

  validateChangeEmail(body:any): Observable<any> {
    return this._http.post< ApiResponse<any>>(this._base + `/api/User/validate-email-change`,body);
  }

  getListFournisseuresn(data: {
    clientFinal_id: number;
    type?: [];
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EsnClient/getListForunisseur?
  clientFinal_id=${data.clientFinal_id}&type[]=1&per_page=${data.per_page}&page=${data?.page}${sort}`);
  }

  getListFournisseurrall(data: {
    clientFinal_id: number;
    type?: number[];
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;

    // Si des types sont définis, concaténez-les avec des virgules dans le paramètre type[]
    const typeParam = data.type ? `&type[]=${data.type.join('&type[]=')}` : '';

    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/EsnClient/getListForunisseur?
  clientFinal_id=${data.clientFinal_id}${typeParam}&per_page=${data.per_page}&page=${data?.page}${sort}`);
  }

  getIndivListFournisseurr(data: {
    clientFinal_id: number;
    type?: number[];
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;


    return this._http.get<
      ApiResponse<any>>(`${this._base}/api/EsnClient/getListForunisseurIndiv?clientFinal_id=${data.clientFinal_id}&per_page=${data.per_page}&page=${data?.page}${sort}`);
  }

  /*add Bulk Candidates*/
  addBulkCandidates(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Company/addBulkFournisseur`,
      data
    );
  }
  /*get bulk candidate */
  getbulkCandidate(data: any) {
    return this._http.get(
      this._base + `/api/Company/exportFournisseur/${data}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }

  /* get  Fournisseur by name*/
  getfournisseurbyname(name: any,company_id:any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/EsnClient/getCompanyByNameForFournisseuer?name=${name}&clientFinal_id=${company_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  getfournisseurbyemail(email: any, id:any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/EsnClient/getCompanyByNameForFournisseuerIndiv?fournisseur_email=${email}&clientFinal_id=${id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  /*get fournisseur  by id */
  getUserById(id: number): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base + `/api/Company/getCompanyByIdWithDetails?company_id=${id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  getesnwithconsultant(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort: number;
  }) {
    return this._http.get<ApiResponse<any>>(`${
      this._base
    }/api/Company/getEsnWithConsultants/${data.id}?
     per_page=${data.per_page || 100}&page=${data.page || 1}&sort=${
      data.sort
    }`);
  }

  // search fournisseur//////
  searchfournisseur(data: any): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/EsnClient/searchInListForunisseur`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }

  downloadcsvfileAddBulksupplier() {
    const url = `${this._base}/api/Company/uploadEmptyFileAddBulkFournisseur`;
    return this._http.get(url, {
      responseType: 'blob', // Changer 'arraybuffer' en 'blob'
      // observe: 'response', // Permet d'obtenir la réponse complète incluant les en-têtes
    });
  }
   // dissocier supplier esn
   dissocierEsn(id:any,client_id: any,type :string,state:number) {
    return this._http.delete<ApiResponse<any>>(
      this._base + `/api/EsnClient/deleteFournisseur?${type}=${id}&client_id=${client_id}&type=${state}`
  
    );
  }
  // dissocierEsn(data:any) {
  //   return this._http.post<ApiResponse<any>>(
  //     this._base + `/api/User/dissociateCandidateFromCompany`,data
  
  //   );
  // }
}
